import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getQuestions = (state) => resolveProp('identity.challengeQuestions', state) || [];

export default createSelector(getQuestions, (questions) => ({
    questions,
}));
